// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10ArR","rootMobile":"styles_rootMobile__20LmS"};